/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const InstanceModification = zod.strictObject({
    created_at: zod.iso.datetime({ offset: true }),
    content_type: zod.string(),
    object_id: zod.string(),
    diff: zod.array(
        zod
            .strictObject({
                op: zod
                    .enum(['add', 'remove', 'replace', 'move', 'copy', 'test'])
                    .describe(
                        '\* `add` - add\n\* `remove` - remove\n\* `replace` - replace\n\* `move` - move\n\* `copy` - copy\n\* `test` - test',
                    ),
                path: zod.string(),
                value: zod.unknown().optional(),
                from: zod.string().optional(),
            })
            .describe(
                'Serializer just there for swagger compliance: see https:\/\/jsonpatch.com\/',
            ),
    ),
    past_value: zod.unknown(),
    new_value: zod.unknown(),
    files: zod.record(zod.string(), zod.url()),
    possible_fields: zod.array(zod.unknown()),
    form_descriptor: zod.unknown().nullable(),
});

export type InstanceModification = zod.input<typeof InstanceModification>;
export type InstanceModificationOutput = zod.output<
    typeof InstanceModification
>;
